/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation PaymentCreateMutation($input: [PaymentCreateInput!]!) {
  PaymentCreate(input: $input) {
    id
    message
    status
  }
}
`
